/* DAnime Shop — custom theme behaviour (V3). Vanilla JS, no dependencies, ~progressive enhancement.
   Everything is feature-detected and fails soft: without JS the page is fully readable and the
   product form submits normally to /cart/add. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $$('.dx-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Dialogs (size guide, store password) ---------- */
  function openDialog(id) {
    var d = document.getElementById(id);
    if (!d || typeof d.showModal !== 'function') return;
    if (!d.open) d.showModal();
    var first = d.querySelector('input, button, a');
    if (first) first.focus();
  }
  var dialogsBound = false;
  function initDialogs() {
    if (!dialogsBound) { dialogsBound = true; document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-dx-open]');
      if (opener) { e.preventDefault(); openDialog(opener.getAttribute('data-dx-open')); return; }
      var closer = e.target.closest && e.target.closest('[data-dx-close]');
      if (closer) { var d = closer.closest('dialog'); if (d) d.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('dx-modal')) e.target.close();
    }); }
    $$('dialog[data-dx-autoopen]').forEach(function (d) { if (typeof d.showModal === 'function') d.showModal(); });
  }

  /* ---------- Launch countdown (password page) ---------- */
  function initCountdown() {
    $$('[data-dx-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-dx-countdown'));
      if (isNaN(target.getTime())) return;
      var parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var timer;
      function tick() {
        var diff = Math.floor((target.getTime() - Date.now()) / 1000);
        if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
        parts.d.textContent = pad(Math.floor(diff / 86400));
        parts.h.textContent = pad(Math.floor((diff % 86400) / 3600));
        parts.m.textContent = pad(Math.floor((diff % 3600) / 60));
        parts.s.textContent = pad(diff % 60);
        el.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var form = $('[data-dx-form]', root);
    if (!form) return;
    var variantsEl = $('[data-dx-variants]', root);
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) { variants = []; }

    var idInput = $('[data-dx-variant-id]', form);
    var atc = $('[data-dx-atc]', form);
    var atcLabel = $('[data-dx-atc-label]', form);
    var priceNow = $('[data-dx-price-now]', root);
    var priceWas = $('[data-dx-price-was]', root);
    var sku = $('[data-dx-sku]', root);
    var msg = $('[data-dx-msg]', form);
    var sticky = $('[data-dx-sticky]', root);
    var stickyPrice = $('[data-dx-sticky-price]', root);
    var stickyBtn = $('[data-dx-sticky-atc]', root);
    var track = $('[data-dx-track]', root);

    function say(text, isLink) {
      if (!msg) return;
      msg.hidden = !text;
      msg.textContent = '';
      if (!text) return;
      msg.appendChild(document.createTextNode(text));
      if (isLink) {
        var a = document.createElement('a');
        a.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
        a.textContent = ' View cart';
        a.style.textDecoration = 'underline';
        msg.appendChild(a);
      }
    }

    function selectedOptions() {
      var fieldsets = $$('.dx-option', form);
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability() {
      var opts = selectedOptions();
      $$('.dx-option', form).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var v = findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
        var c = $('input:checked', fs), label = $('[data-dx-option-value]', fs);
        if (c && label) label.textContent = c.value;
      });
    }
    function setButton(avail) {
      [atc, stickyBtn].forEach(function (b) { if (b) b.disabled = !avail; });
      var text = avail ? 'Add to cart' : 'Sold out';
      if (atcLabel) atcLabel.textContent = text;
      if (stickyBtn) stickyBtn.textContent = text;
    }
    function scrollToMedia(id) {
      if (!id || !track) return;
      var item = $('[data-media-id="' + id + '"]', track);
      if (!item) return;
      if (window.matchMedia('(min-width: 1000px)').matches) {
        item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      } else {
        track.scrollTo({ left: item.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    function onVariantChange(userInitiated) {
      var v = findVariant(selectedOptions());
      markAvailability();
      if (!v) { setButton(false); if (atcLabel) atcLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id; idInput.disabled = !v.available;
      if (priceNow) priceNow.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (priceWas) { priceWas.hidden = !v.was; priceWas.textContent = v.was || ''; }
      if (sku) sku.textContent = v.sku || '';
      setButton(v.available);
      try {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
      if (userInitiated) scrollToMedia(v.media);
    }
    $$('.dx-option__input', form).forEach(function (i) { i.addEventListener('change', function () { onVariantChange(true); }); });
    markAvailability();

    /* quantity stepper */
    var qty = $('[data-dx-qty-input]', form);
    var minus = $('[data-dx-qty-minus]', form), plus = $('[data-dx-qty-plus]', form);
    function clamp() { var n = parseInt(qty.value, 10); if (isNaN(n) || n < 1) n = 1; qty.value = n; }
    if (qty) {
      qty.addEventListener('change', clamp);
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    /* add to cart: uses the base theme's cart events so the cart drawer + header count update */
    var busy = false;
    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      if (!window.fetch || !window.FormData) return; // native submit fallback
      e.preventDefault();
      if (idInput.disabled) return;
      busy = true; say('');
      [atc, stickyBtn].forEach(function (b) { if (b) b.disabled = true; });
      if (atcLabel) atcLabel.textContent = 'Adding...';
      var fd = new FormData(form);
      var count = parseInt(fd.get('quantity'), 10) || 1;

      var Events = null, deferred = null;
      var ready = import('@shopify/events').then(function (m) { Events = m; }).catch(function () { Events = null; });

      ready.then(function () {
        if (Events && Events.CartLinesUpdateEvent) {
          try {
            deferred = Events.CartLinesUpdateEvent.createPromise();
            form.dispatchEvent(new Events.CartLinesUpdateEvent({
              action: 'add', context: 'product',
              lines: [{ merchandiseId: String(fd.get('id')), quantity: count }],
              promise: deferred.promise
            }));
          } catch (err) { deferred = null; }
        }
        return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || res.body.status) {
            var text = (res.body && (res.body.description || res.body.message)) || 'Could not add to cart.';
            if (deferred) deferred.reject(new Error(text));
            throw new Error(text);
          }
          return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (deferred && Events) {
                deferred.resolve({
                  cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                  detail: { items: cart.items, source: 'dx-product', sourceId: root.getAttribute('data-section-id'), itemCount: count, productId: undefined, sections: res.body.sections, didError: false }
                });
              }
              say('Added to cart.', true);
            });
        })
        .catch(function (err) {
          say(err && err.message ? err.message : 'Something went wrong. Please try again.');
        })
        .then(function () {
          busy = false;
          var v = findVariant(selectedOptions());
          setButton(!!(v && v.available));
        });
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });

    /* gallery counter (mobile carousel) */
    var current = $('[data-dx-current]', root);
    if (track && current && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) current.textContent = String(parseInt(en.target.getAttribute('data-index'), 10) + 1);
        });
      }, { root: track, threshold: [0.6] });
      $$('.dx-gallery__item', track).forEach(function (it) { io.observe(it); });
    }

    /* sticky mobile bar: show once the main button has scrolled out of view */
    if (sticky && atc && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io2 = new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', out);
      });
      io2.observe(atc);
    }
  }

  /* ---------- Related products (section rendering API) ---------- */
  function initRelated() {
    $$('[data-dx-related]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.querySelector('.dx-grid')) return;
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-dx-related]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(); }
      }).catch(function () { /* no recommendations, stay empty */ });
    });
  }

  function init() {
    initReveal();
    initDialogs();
    initCountdown();
    $$('[data-dx-pdp]').forEach(initProduct);
    initRelated();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
